import {
  Layout as AntLayout,
  LayoutProps as AntdLayoutProps,
  Menu,
} from "antd";
import React from "react";
const { Header, Footer, Sider, Content } = AntLayout;
type LayoutProps = {
  /** Whether to include a sidebar */
  hasSider?: boolean;
  /** Header content */
  headerContent?: React.ReactNode;
  /** Sidebar content */
  siderContent?: React.ReactNode;
  /** Footer content */
  footerContent?: React.ReactNode;
  /** Main content */
  children: React.ReactNode;
} & AntdLayoutProps;
const Layout = ({
  hasSider = false,
  headerContent,
  siderContent,
  footerContent,
  children,
  ...rest
}: LayoutProps) => {
  return (
    <AntLayout style={{ minHeight: "100vh" }} {...rest}>
      {headerContent ? (
        <Header style={{ color: "white", textAlign: "center" }}>
          {headerContent}
        </Header>
      ) : null}
      <AntLayout>
        {hasSider && (
          <Sider width={200} style={{ background: "#f0f2f5" }}>
            <Menu
              mode="inline"
              defaultSelectedKeys={["1"]}
              style={{ height: "100%", borderRight: 0 }}
            >
              {siderContent}
            </Menu>
          </Sider>
        )}
        <Content style={{ padding: "24px", background: "#fff" }}>
          {children}
        </Content>
      </AntLayout>
      {footerContent ? (
        <Footer style={{ textAlign: "center" }}>{footerContent}</Footer>
      ) : null}
    </AntLayout>
  );
};
export default Layout;
